import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL;

// Multi-select of product numbers WITHIN a family, sourced from product metadata
// (/product-families/:key → products). family = familyKey, value = string[].
// Legacy product numbers not in the family list are still shown as chips.
export default function ProductNumberPicker({ family, value, onChange, getToken, accent = '#2dd4bf' }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!family) { setProducts([]); return undefined; }
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const res = await window.fetch(`${API_BASE}/product-families/${encodeURIComponent(family)}`, { headers: { Authorization: `Bearer ${token}` } });
        const d = await res.json();
        if (!cancelled && d.ok) setProducts(d.products || []);
      } catch { /* leave empty */ }
    })();
    return () => { cancelled = true; };
  }, [family, getToken]);

  const arr = Array.isArray(value) ? value : [];
  const add = (pn) => { if (pn && !arr.includes(pn)) onChange([...arr, pn]); };
  const remove = (pn) => onChange(arr.filter(x => x !== pn));

  const inp = {
    background: 'var(--ni-panel)', border: '1px solid var(--ni-border-soft)', color: 'var(--ni-text)',
    borderRadius: 6, padding: '8px 12px', fontSize: 13, width: '100%', boxSizing: 'border-box',
  };

  if (!family) {
    return <div style={{ fontSize: 12, color: 'var(--ni-text-muted)' }}>Select a product family first.</div>;
  }

  return (
    <div>
      <select value="" onChange={e => { add(e.target.value); e.target.value = ''; }} style={inp}>
        <option value="">+ Add product number…</option>
        {products.filter(p => !arr.includes(p.productNumber)).map(p => (
          <option key={p.productNumber} value={p.productNumber}>{p.productNumber}{p.name ? ` — ${p.name}` : ''}</option>
        ))}
      </select>
      {arr.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
          {arr.map(pn => {
            const p = products.find(x => x.productNumber === pn);
            return (
              <span key={pn} title={p ? (p.name || '') : 'Not in this family'}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 20,
                  fontSize: 12, fontWeight: 700, background: accent + '22', color: accent }}>
                {pn}
                <button type="button" onClick={() => remove(pn)}
                  style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, fontSize: 13, lineHeight: 1 }}>×</button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}
